import {createContext, useState} from "react"

export const FormBuilderContext = createContext(undefined)

const FormBuilderProvider = ({children}) => {
    const [structure, setStructure] = useState([])
    const [selectItemId, setSelectItemId] = useState(null)
    const [errorList, setErrorList] = useState([])

    const handleSelectItem = (id) => setSelectItemId(prev => prev !== id ? id : null)

    const removeItem = (e) => {
        e.preventDefault()

        setStructure(prev => prev.filter(i => i.id !== selectItemId))
        handleSelectItem(null)
    }

    return (
        <FormBuilderContext.Provider value={{structure, setStructure, selectItemId, handleSelectItem, removeItem, errorList, setErrorList}}>
            {children}
        </FormBuilderContext.Provider>
    )
}

export default FormBuilderProvider